<template>
  <div class="dashboard-container flex flex-wrap flex-col">
    <div id="pbi" class="pbiFrame" />
  </div>
</template>

<script>
// @flow
import { mapActions, mapGetters } from 'vuex';

export default {
  name: 'RastreabilidadeChip',
  data() {
    return {
      biElement: ''
    };
  },
  async mounted() {
    await this.fetchToken();
    await this.fetchViews();
    await this.fetchAllDistributors();
    await this.fetchToken();

    if (!this.tokenID) return;
    this.showDash();
  },
  computed: {
    ...mapGetters({
      tokenID: 'powerbi/token',
      reportId: 'powerbi/reportId',
      distributors: 'distributors/distributors',
      views: 'view/views'
    }),
    distributorsForFilter() {
      return this.distributors.map(item => item.name);
    },
    viewsFormatted() {
      const array = this.views.flatMap(item => item.views);

      return array.map(item => item.name) || [];
    }
  },
  methods: {
    ...mapActions({
      fetchToken: 'powerbi/fetchSigTimRastreabilidadeChipToken',
      fetchAllDistributors: 'distributors/fetchAllDistributors',
      fetchViews: 'view/fetchViewsRelated'
    }),
    showDash() {
      const filters = [];
      this.biElement = this.$el.querySelector('#pbi');
      const config = {
        type: 'report',
        tokenType: 1,
        accessToken: this.tokenID,
        embedUrl: 'https://app.powerbi.com/reportEmbed',
        permissions: 1,
        id: this.reportId,
        settings: {
          filterPaneEnabled: false,
          navContentPaneEnabled: true
        }
      };

      if (this.viewsFormatted.length) {
        const viewFilter = {
          $schema: 'http://powerbi.com/product/schema#basic',
          target: {
            table: 'view_active_places',
            column: 'view_executiva'
          },
          operator: 'In',
          values: this.viewsFormatted
        };
        filters.push(viewFilter);
      }

      const distributorFilter = {
        $schema: 'http://powerbi.com/product/schema#basic',
        target: {
          table: 'view_active_places',
          column: 'db_name'
        },
        operator: 'In',
        values: this.distributorsForFilter
      };
      filters.push(distributorFilter);
      const rep = window.powerbi.embed(this.biElement, config);
      rep.on('loaded', () => {
        console.log(filters);
        rep.setFilters(filters);
      });
    }
  }
};
</script>

<style lang="scss">
  @import url('./powerbi.css');
</style>
